import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import he from "he";
import image_logo from "../../assets/img/general/1assd.png";
import "../../assets/css/Header.css";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Header() {
  const [allRecords, setAllRecords] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    (async () => await fetchMenueData())();
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = (key) => {
    setExpandedMenus((previous) => ({
      ...previous,
      [key]: !previous[key],
    }));
  };

  // ================= MENU HELPERS =================

  const getgrandSubMenu = (
    recordsArr,
    parentVal,
    item02Val = 0,
    item02bVal = 0,
  ) => {
    return recordsArr
      .filter(
        (item) =>
          item.item01 === parentVal &&
          item.item02 === item02Val &&
          Number(item.item02b) > Number(item02bVal),
      )
      .map((item, index) => (
        <li key={`${item.item01}-${index}`} className="dropdown">
          <Link
            to={
              item.linker !== "" && item.linker !== null
                ? item.linker
                : `/${he.decode(item.item03.replace(/ & /g, "_"))}/${item.item02b}`
            }
            target={item.triger}
            onClick={closeMobileMenu}
          >
            {he.decode(item.item03)}
          </Link>
        </li>
      ));
  };

  const getSubMenu = (recordsArr, parentVal, item02Val = 0, item02bVal = 0) => {
    return recordsArr
      .filter(
        (item) =>
          item.item01 === parentVal &&
          Number(item.item02) > Number(item02Val) &&
          Number(item.item02b) === Number(item02bVal),
      )
      .map((item, index) => {
        const currentVal = item.item02;

        const hasGrandChildren = recordsArr.some(
          (i) =>
            i.item01 === parentVal &&
            i.item02 === currentVal &&
            i.item02b > item02bVal,
        );

        return (
          <li key={`${item.item01}-${index}`} className="dropdown">
            <Link
              to={
                item.linker !== "" && item.linker !== null
                  ? item.linker
                  : `/${he.decode(item.item03.replace(/ & /g, "_"))}/${item.item02}`
              }
              target={item.triger}
              onClick={closeMobileMenu}
            >
              {he.decode(item.item03)}
            </Link>

            {hasGrandChildren && (
              <ul>{getgrandSubMenu(recordsArr, parentVal, currentVal)}</ul>
            )}
          </li>
        );
      });
  };

  async function fetchMenueData() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdatab?itemName[eq]=menue_tab&status02[eq]=publish`,
        ),
      ]);

      const [menueData] = responses;

      if (menueData.data.status === 200) {
        setAllRecords(menueData.data.allData || []);
      }
    } catch (error) {
      console.log("Error loading menu");
    }
  }

  // ================= UI =================

  return (
    <>
      {/* TOP BAR: MINISTRY IDENTITY + SOCIAL MEDIA */}
      <div className="topbar fmhud-topbar">
        <div className="container fmhud-topbar-inner">
          <Link
            to="/"
            className="fmhud-brand d-flex align-items-center"
            aria-label="Federal Ministry of Housing and Urban Development homepage"
          >
            <img
              src={image_logo}
              alt="Federal Ministry of Housing and Urban Development emblem"
              className="fmhud-brand-logo"
              loading="eager"
              decoding="async"
            />

            <span className="fmhud-brand-divider" aria-hidden="true" />

            <span className="fmhud-brand-copy">
              <span className="fmhud-brand-kicker">FEDERAL MINISTRY OF</span>

              <span className="fmhud-brand-title">
                HOUSING &amp; URBAN DEVELOPMENT
              </span>

              <span className="fmhud-brand-country">
                Federal Republic of Nigeria
              </span>
            </span>
          </Link>

          <div className="social-links fmhud-social-links">
            <a
              href="https://twitter.com/FMHUD_NG"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit FMHUD on X"
              title="X (Twitter)"
            >
              <i className="fa-brands fa-x-twitter" aria-hidden="true" />
            </a>

            <a
              href="https://www.facebook.com/FMHUDNG"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit FMHUD on Facebook"
              title="Facebook"
            >
              <i className="fa-brands fa-facebook-f" aria-hidden="true" />
            </a>

            <a
              href="https://www.linkedin.com/in/FMHUDNG"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit FMHUD on LinkedIn"
              title="LinkedIn"
            >
              <i className="fa-brands fa-linkedin-in" aria-hidden="true" />
            </a>

            <a
              href="https://www.instagram.com/fmhudng"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit FMHUD on Instagram"
              title="Instagram"
            >
              <i className="fa-brands fa-instagram" aria-hidden="true" />
            </a>

            <a
              href="https://www.youtube.com/channel/UC3P5Hj-gEdcf-cNJS8pAQ2g"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit FMHUD on YouTube"
              title="YouTube"
            >
              <i className="fa-brands fa-youtube" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>

      {/* MAIN HEADER: CONTACT DETAILS + NAVIGATION */}
      <header id="header" className="branding fmhud-main-header">
        <div className="container fmhud-main-header-inner">
          <div className="fmhud-header-contact">
            <a
              href="mailto:info@fmhud.gov.ng"
              className="fmhud-contact-item"
              aria-label="Email the Federal Ministry of Housing and Urban Development"
            >
              <span className="fmhud-contact-icon">
                <i className="fa-solid fa-envelope" aria-hidden="true" />
              </span>
              <span className="fmhud-contact-copy">
                <span className="fmhud-contact-label">EMAIL US</span>
                <span className="fmhud-contact-value">info@fmhud.gov.ng</span>
              </span>
            </a>

            <span className="fmhud-contact-separator" aria-hidden="true" />

            <a
              href="tel:+2348061743313"
              className="fmhud-contact-item"
              aria-label="Call the Federal Ministry of Housing and Urban Development"
            >
              <span className="fmhud-contact-icon">
                <i className="fa-solid fa-phone" aria-hidden="true" />
              </span>
              <span className="fmhud-contact-copy">
                <span className="fmhud-contact-label">CALL US</span>
                <span className="fmhud-contact-value">+234 806 174 3313</span>
              </span>
            </a>
          </div>

          {/* EXISTING DYNAMIC NAVIGATION */}
          <nav
            id="navmenu"
            className={`navmenu ${mobileMenuOpen ? "mobile-nav-active" : ""}`}
            aria-label="Main navigation"
          >
            <ul>
              {allRecords.map((item, index) => {
                if (Number(item.item02) === 0 && Number(item.item02b) === 0) {
                  const hasChildren = allRecords.some(
                    (record) =>
                      record.item01 === item.item01 &&
                      Number(record.item02) > 0,
                  );

                  const menuLabel = he.decode(item.item03);

                  const menuPath =
                    item.linker !== "" && item.linker !== null
                      ? item.linker
                      : `/${he.decode(
                          item.item03.replace(/ & /g, "_"),
                        )}/${item.item01}`;

                  return (
                    <li
                      key={`top-${index}`}
                      className={hasChildren ? "dropdown" : ""}
                    >
                      <div className="fmhud-mobile-menu-row">
                        <Link
                          to={menuPath}
                          target={item.triger || undefined}
                          onClick={closeMobileMenu}
                          aria-haspopup={hasChildren ? "true" : undefined}
                        >
                          <span>{menuLabel}</span>
                        </Link>

                        {hasChildren && (
                          <button
                            type="button"
                            className="fmhud-submenu-toggle"
                            aria-label={`Toggle ${menuLabel} submenu`}
                            aria-expanded={!!expandedMenus[item.item01]}
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              toggleSubmenu(item.item01);
                            }}
                          >
                            <i
                              className={`fa-solid ${
                                expandedMenus[item.item01]
                                  ? "fa-chevron-up"
                                  : "fa-chevron-down"
                              }`}
                              aria-hidden="true"
                            />
                          </button>
                        )}
                      </div>

                      {hasChildren && (
                        <ul
                          className={
                            expandedMenus[item.item01]
                              ? "fmhud-submenu-expanded"
                              : ""
                          }
                        >
                          {getSubMenu(allRecords, item.item01)}
                        </ul>
                      )}
                    </li>
                  );
                }

                return null;
              })}
            </ul>

            <button
              type="button"
              className="mobile-nav-toggle d-xl-none"
              onClick={toggleMobileMenu}
              aria-label={
                mobileMenuOpen
                  ? "Close navigation menu"
                  : "Open navigation menu"
              }
              aria-expanded={mobileMenuOpen}
              aria-controls="navmenu"
            >
              <i
                className={`fa-solid ${
                  mobileMenuOpen ? "fa-xmark" : "fa-bars"
                }`}
                aria-hidden="true"
              />
            </button>
          </nav>

          {/* MOBILE MENU OVERLAY */}
          {mobileMenuOpen && (
            <div
              className="mobile-menu-overlay"
              onClick={closeMobileMenu}
              aria-hidden="true"
            />
          )}
        </div>
      </header>
    </>
  );
}

export default Header;
